export default __webpack_public_path__ + "static/media/reverse-assumptions.3685813a.jpg";